import { and, asc, desc, eq } from "drizzle-orm";
import {
  type PowerSyncDrizzleDB,
  purchase_order,
  purchase_order_line,
  supplier,
} from "@comandero/powersync";
import {
  livePurchaseOrderFilters,
  livePurchaseOrderLineFilters,
  liveSupplierFilters,
} from "../live/filters";

/** Proveedores de la org, por nombre. */
export function getSuppliersQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(supplier)
    .where(and(eq(supplier.organization_id, organizationId), ...liveSupplierFilters()))
    .orderBy(asc(supplier.name));
}

/** Órdenes de compra de la org, más recientes primero. */
export function getPurchaseOrdersQuery(db: PowerSyncDrizzleDB, organizationId: string) {
  return db
    .select()
    .from(purchase_order)
    .where(and(eq(purchase_order.organization_id, organizationId), ...livePurchaseOrderFilters()))
    .orderBy(desc(purchase_order.created_at));
}

// Lookup id-scoped (keyed): detalle por id; ver una fila borrada es inocuo.
export function getPurchaseOrderByIdQuery(db: PowerSyncDrizzleDB, purchaseOrderId: string) {
  return db.select().from(purchase_order).where(eq(purchase_order.id, purchaseOrderId)).limit(1);
}

/** Líneas de una orden de compra. */
export function getPurchaseOrderLinesQuery(db: PowerSyncDrizzleDB, purchaseOrderId: string) {
  return db
    .select()
    .from(purchase_order_line)
    .where(
      and(
        eq(purchase_order_line.purchase_order_id, purchaseOrderId),
        ...livePurchaseOrderLineFilters(),
      ),
    )
    .orderBy(asc(purchase_order_line.created_at));
}
